import { formatter, Ajax, findMax } from './common_product_list_pro'
cb.define([], function () { //商品列表
  var PC_pc_productlist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      formatter(viewmodel)
      let gridModel = viewmodel.getGridModel();
      gridModel.on('beforeDblClick', (args) => {                
        args.carryParams.productApplyRangeId = args.rowData.productApplyRangeId;                
        args.carryParams.isCreator = args.rowData.isCreator;                
        args.carryParams.isApplied = args.rowData.isApplied;      
        args.ids = {
          customerId: args.rowData.customerId,
          shopId: args.rowData.shopId,
          orgId: args.rowData.orgId
        }
        // args.carryParams.state = {
        //   iStatus: args.rowData.iStatus,
        //   iUOrderStatus: args.rowData.iUOrderStatus
        // }      
      })     
      //分配组织字段所在的隐藏的viewmodel--begin
      var prosuitorgReferModel = new cb.models.ReferModel({
        cRefType: 'aa_orgtree',
        multiple: true
      });
      viewmodel.addProperty('prosuitorg', prosuitorgReferModel);
      prosuitorgReferModel.setVisible(false);  
      //分配组织的批量操作
      viewmodel.on('addprosuitorg', function (args) {
        var selectedRows = viewmodel.getGridModel().getSelectedRows();
        if (selectedRows == undefined || selectedRows.length == 0) {
          cb.utils.alert('请先选择要分配组织的商品！', 'warning');
          return;
        }
        prosuitorgReferModel.setCache('args', args);
        prosuitorgReferModel.browse(true);
      });
      prosuitorgReferModel.on('afterValueChange', function (data) {
        var selectedRows = viewmodel.getGridModel().getSelectedRows();
        var selectedorgId = data.value.length ? data.value.map(v => v.id) : [];
        var url = '/bill/batchDo?action=addprosuitorg';
        var proxy = cb.rest.DynamicProxy.create({
          ensure: {
            url: url,
            method: 'POST'
          }
        });
        var datas = [];
        if (selectedorgId === undefined || selectedorgId.length === 0) {
          cb.utils.alert('未选择要分配的组织！', 'warning');
        } else {
          var length = selectedRows.length;
          for (var i = 0; i < length; i++) {
            datas.push({
              "productId": selectedRows[i]["id"],
              "orgIds": selectedorgId,
              "product_name": selectedRows[i]["name"]
            });
          }
          var params = {
            billnum: "pc_productlist",
            data: JSON.stringify(datas),
            condition: viewmodel.getCache('lastSearchCondition').condition
          }
          proxy.ensure(params, function (err, result) {
            if (err) {
              cb.utils.alert(err.message, 'error');
              return;
            }
            if (result) {
              var count = result.count;
              var sucessCount = result.sucessCount;
              var failCount = result.failCount;
              if (result.messages.length > 0) {
                var messages = result.messages;
                var products = '';
                var length = messages.length;
                for (var i = 0; i < length; i++) {
                  products += messages[i];
                  products += "、";
                }
                var products2 = products.substring(0, products.length - 1);
                cb.utils.alert('共' + count + '条，成功' + sucessCount + '条。 ' + products2 + '，此次操作未对其生效！', 'warning');
              } else {
                cb.utils.alert('共' + count + '条，成功' + sucessCount + '条。', 'success');
              }

            }
            viewmodel.execute('refresh');
          });
        }
      });
      //分配组织字段所在的隐藏的viewmodel--end
      viewmodel.on('beforeTempexport', (args) => {  
        if (args.params) {              
          if (args.params.cCommand == "cmdPriceAndCurrentExport") {
            if (viewmodel.getCache('lastSearchCondition'))
              args.data["condition"] = viewmodel.getCache('lastSearchCondition').condition
          }
          else if(args.params.cCommand == "cmdProAndSkuExport"){
            if (viewmodel.getCache('lastSearchCondition'))
            args.data["condition"] = viewmodel.getCache('lastSearchCondition').condition
            let selectData = gridModel.getSelectedRows();
            if(selectData.length != 0){
              args.data.externalData = selectData.map(v => v.id).join();
            }
          }
        }
      })        
      viewmodel.on('beforeEdit', (args) => {                
        args.carry.carryParams.productApplyRangeId = args.carry.rowData.productApplyRangeId;                
        args.carry.carryParams.isCreator = args.carry.rowData.isCreator;                
        args.carry.carryParams.isApplied = args.carry.rowData.isApplied; 
        args.carry.ids = {
          customerId: args.carry.rowData.customerId,
          shopId: args.carry.rowData.shopId,
          orgId: args.carry.rowData.orgId
        }
        // args.carry.carryParams.state= {
        // 	iStatus:args.carry.rowData.iStatus,
        // 	iUOrderStatus:args.carry.rowData.iUOrderStatus
        // }
      })      

      viewmodel.on('beforeBatchoutput', (args) => {
        let selectData = gridModel.getSelectedRows();
        args.data.externalData = selectData.map(v => v.productApplyRangeId).join();
        //console.log(args)
      })      
      //批量上下架
      function _fnshelve(args) {
        let selectedRows;
        if (args.params) {
          if (args.params.index < 0) {
            cb.utils.alert('未选择商品', 'warning');
            return false;
          }
          selectedRows.push(gridModel.getRow(args.params.index));
        } else {
          selectedRows = gridModel.getSelectedRows();
          if (!selectedRows.length) {
            cb.utils.alert('未选择商品', 'warning');
            return false;
          }
          let _selectRows = selectedRows.filter(v => v.virtualProductAttribute != 1 && !v["detail!stopstatus"])
          if (!_selectRows.length) { //审核未通过
            cb.utils.alert('停用状态的商品、储值卡商品不能上下架', 'warning');
            return false;
          }
          const userType = cb.rest.AppContext.user ? cb.rest.AppContext.user.userType : null;
          let shopProIfCheck = cb.rest.AppContext.option ? cb.rest.AppContext.option.shopProIfCheck : null;
          if (userType === 4 || userType === 5) { // 商家操作员登陆
            switch (shopProIfCheck) {
              case '1':
                _selectRows = _selectRows.filter(v => !v.isCreator || (v.isCreator && v.platFormStaus === 1));
                if (!_selectRows.length) {
                  cb.utils.alert('商家商品新建和修改时需要审核后才能上架', 'warning')
                  return false
                }
                break;
              case '2':
                _selectRows = _selectRows.filter(v => !v.isCreator || (v.isCreator && v.platFormStaus === 1));
                if (!_selectRows.length) {
                  cb.utils.alert('商家商品未通过审核不能上下架', 'warning')
                  return false
                }
                break;
              default:

            }
          }
          let __selectRows = [];
          switch (args.cItemName) {
            case 'btnUMallUp':
              __selectRows = _selectRows.filter(v => !!v['detail!iStatus'] === false)
              break;
            case 'btnUMallDown':
              __selectRows = _selectRows.filter(v => !!v['detail!iStatus'] === true)
              break;
            case 'btnUOrderUp':
              __selectRows = _selectRows.filter(v => !!v['detail!iUOrderStatus'] === false)
              break;
            case 'btnUOrderDown':
              __selectRows = _selectRows.filter(v => !!v['detail!iUOrderStatus'] === true)
              break;
            default:
          }
          if (!__selectRows.length) {
            cb.utils.alert(('请选择未' + args.cShowCaption + '的商品'), 'warning');
            return false
          }
          selectedRows = _selectRows
        }
        let datas = [];
        let length = selectedRows.length;
        for (let i = 0; i < length; i++) {
          datas.push({
            "id": selectedRows[i]["id"],
            "isCreator": selectedRows[i]["isCreator"],
            "biz": args.cParameter,
            "productApplyRangeId": selectedRows[i]["productApplyRangeId"]
          });
        }
        Ajax(args, datas, viewmodel)
      }
      viewmodel.on('shelve', function (args) {
        _fnshelve(args)
      });
      viewmodel.on('unshelve', function (args) {
        _fnshelve(args)
      });
      const startOrStop = (args) => {
        let selectedRows = [];
        if (args.params) {
          if (args.params.index < 0) {
            cb.utils.alert('未选择商品！', 'warning');
            return false;
          }
          selectedRows.push(gridModel.getRow(args.params.index));
        } else {
          selectedRows = gridModel.getSelectedRows();
          if (!selectedRows.length) {
            cb.utils.alert('未选择商品！', 'warning');
            return false;
          }
          let _selectRows = [];
          // 'detail!stopstatus' true -> 停用； false->启用
          switch (args.cItemName) {
            case "btnBatchEnable": // 启用 
              _selectRows = selectedRows.filter(v => v['detail!stopstatus'] === true || v['detail!stopstatus'] === 'true')
              break;
            case "btnBatchDisable": // 停用
              _selectRows = selectedRows.filter(v => v['detail!stopstatus'] === false || v['detail!stopstatus'] === 'false')
              break;
            default:
          }
          if (!_selectRows.length) { //审核未通过
            cb.utils.alert('请选择未' + args.cShowCaption + '状态的商品', 'warning');
            return false;
          }
          selectedRows = _selectRows
        }
        let datas = [];
        let length = selectedRows.length;
        for (let i = 0; i < length; i++) {
          datas.push({
            "id": selectedRows[i]["id"],
            "isCreator": selectedRows[i]["isCreator"],
            "biz": args.cParameter,
            "productApplyRangeId": selectedRows[i]["productApplyRangeId"]
          });
        }
        Ajax(args, datas, viewmodel)
      }
      viewmodel.on("batchenable", function (args) { // 启用
        startOrStop(args)
      });
      viewmodel.on("batchdisable", function (args) { // 停用
        let proxy = cb.rest.DynamicProxy.create({ _label: { url: '/api/upc/getOption/appliedControlledByCreator', method: 'GET' } });
        proxy._label({}, (err, params) => {
          if(err) {
            cb.utils.alert(err.message, 'error');
            return false;
          }
          let appliedControlledByCreator = params.appliedControlledByCreator;
          if(appliedControlledByCreator == "1") {
            cb.utils.confirm(`商品停用时，商品（包括分配给下级经销商或组织的商品）都会自动下架!`, function () {
              startOrStop(args)
            });
          }
          else {
            startOrStop(args)
          }
        })
      });
      //商品标签字段所在的隐藏的viewmodel
      var tagReferModel = new cb.models.ReferModel({ cRefType: 'pc_tagref', multiple: 'true' });
      viewmodel.addProperty('tagName', tagReferModel);
      tagReferModel.setVisible(false)
      //加入商品标签的批量操作
      viewmodel.on('batchtag', function (args) {
        tagReferModel.setCache('args', args);
        tagReferModel.setCondition({});
        tagReferModel.browse(true);
      });
      viewmodel.on('batchcleartag', function (args) {
        tagReferModel.setCache('args', args);
        tagReferModel.setCondition({ option: 'clear' });
        tagReferModel.browse(true);
      });
      //设置商品标签之前判断是否选择商品
      tagReferModel.on('beforeBrowse', function (data) {
        var selectedRows = gridModel.getSelectedRows();
        if (selectedRows == undefined || selectedRows.length == 0) {
          cb.utils.alert('未选择商品！', 'warning');
          return false;
        }
      });
      //设置商品标签之前判断是否选择商品
      tagReferModel.on('afterValueChange', function (args) {
        Object.assign(args, this.getCache('args'));
        if (args && !args.value) {
          cb.utils.alert('未选择商品标签！', 'warning');
          return false
        }
        if (args.cAction == 'batchtag') {
          let tag_positionArr = args.value.map(val => {
            if (val.scope.indexOf('1') >= 0) {
              return val.tag_position
            }
          })
          let { max } = findMax(tag_positionArr);
          if (max > 1) {
            cb.utils.alert('前端展示的标签位置是唯一的', 'warning');
            return false
          }
        }
        var selectedRows = gridModel.getSelectedRows();
        if (!selectedRows.length) {
          cb.utils.alert('未选择商品！', 'warning');
          return false
        }
        let tags = args.value.map(v => {
          return (v.id).toString()
        })
        var datas = [];
        var length = selectedRows.length;
        for (var i = 0; i < length; i++) {
          datas.push({
            "id": selectedRows[i]["id"],
            "tags": tags
          });
        }
        Ajax(args, datas, viewmodel)
      })
    }
  }
  try {
    module.exports = PC_pc_productlist_VM_Extend;
  } catch (error) {
    // 当 类型 为 档案 的时候
  }
  return PC_pc_productlist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_productlist_VM.Extend.js